<script setup lang="ts">

import {ActivityLogEntry} from "@hantera/design-system";
import Invoice from '../Invoices/Invoice.vue'

const props = defineProps<{
  entry: ActivityLogEntry
}>()

</script>

<template>
  <Invoice :invoice="entry.dynamic.invoice" :expanded="false" />
</template>

<style scoped>

</style>